module.exports = __webpack_public_path__ + "static/fonts/Metric-Medium.f15d156.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/metric/Metric-Medium.woff
// module id = UgSE
// module chunks = 88